import { IGetCardLogo } from '../../interfaces';
import cardLogos from './cardLogos';
import ECardType from '../../interfaces/ECardType';

const getCardLogo = ({ cardType }: IGetCardLogo): string | undefined =>
  cardType && cardLogos[cardType.toLowerCase() as keyof typeof ECardType];

export default getCardLogo;
